import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { buildUrl } from '@utils/url/url.util';
import { BaseRequestParams } from 'types/RequestParams';
import { Utils } from '@utils/Utils';
import { ActionResponse, ChargingStationTemplateDataResult } from '../../types/DataResult';
import { RESTServerRoute } from '../../types/Server';
import { ChargingStationTemplate } from '../../types/ChargingStationTemplate';

@Injectable()
export class TemplateApiService {
  private httpClient = inject(HttpClient);

  public getChargerTemplates(params: BaseRequestParams = {}): Observable<ChargingStationTemplateDataResult> {
    return this.httpClient.get<ChargingStationTemplateDataResult>(RESTServerRoute.REST_CHARGING_STATION_TEMPLATES, {
      params: Utils.cloneObjectAsHttpParams(params),
    });
  }

  public getChargerTemplate(templateId: string): Observable<ChargingStationTemplate> {
    return this.httpClient.get<ChargingStationTemplate>(
      buildUrl(RESTServerRoute.REST_CHARGING_STATION_TEMPLATE, { id: templateId }),
    );
  }

  public createChargerTemplate(template: ChargingStationTemplate): Observable<ChargingStationTemplate> {
    return this.httpClient.post<ChargingStationTemplate>(RESTServerRoute.REST_CHARGING_STATION_TEMPLATES, template);
  }

  public updateChargerTemplate(
    templateId: string,
    template: ChargingStationTemplate,
  ): Observable<ChargingStationTemplate> {
    return this.httpClient.put<ChargingStationTemplate>(
      buildUrl(RESTServerRoute.REST_CHARGING_STATION_TEMPLATE, { id: templateId }),
      template,
    );
  }

  public deleteChargerTemplate(templateId: string): Observable<ActionResponse> {
    return this.httpClient.delete<ActionResponse>(
      buildUrl(RESTServerRoute.REST_CHARGING_STATION_TEMPLATE, { id: templateId }),
    );
  }
}
